import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from "../plugins/axios";
import Main from '../pages/client/Main.vue'
import store from "../store/index"

Vue.use(VueRouter)

const routes = [

    {
        path: '/common/kcp/cert/request',
        name: 'KCPCertRequest',
        component: () => import('../pages/common/kcp/KCPCertRequest.vue'),
        props: true
    },
    {
        path: '/common/kcp/cert/response',
        name: 'KCPCertResponse',
        component: () => import('../pages/common/kcp/KCPCertResponse.vue'),
        props: true
    },
    {
        path: '/plugins/kcp/kcp-cert/request',
        component: () => import('../pages/plugins/kcp/kcp-cert/request.vue'),
        props: true
    },
    {
        path: '/plugins/kcp/kcp-cert/response',
        component: () => import('../pages/plugins/kcp/kcp-cert/response.vue'),
        props: true
    },
    
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 사용자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // Main 페이지
        path: '/',
        component: Main
    },
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 관리자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 메인
        path: '/console',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/Main.vue'),
        props: true,
    },
    {
        // 관리자 - 대시보드
        path: '/console/dashboard',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/Dashboard.vue'),
        props: true
    },
    {
        // 관리자 - 회원등급
        path: '/console/user/levels',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/LevelList.vue'),
        props: true,
        scope: ["console"]
    },
    {
        // 관리자 - 탈퇴회원
        path: '/console/user/withdrawals',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/WithdrawalList.vue'),
        props: true,
        scope: ["console"]
    },
    {
        // 관리자 - 회원목록
        path: "/console/users",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/UserList.vue'),
        props: true,
        scope: ["console"]
    },
    {
        // 관리자 - 회원목록
        path: "/console/users/create",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/UserView.vue'),
        props: true,
        scope: ["console"]
    },
    {
        // 관리자 - 회원목록
        path: "/console/users/:_user",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/UserView.vue'),
        props: true,
        scope: ["console"]
    },
    {
        // 관리자 - 담당자 관리
        path: "/console/user/workers",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/WorkerList.vue'),
        props: true,
        scope: ["console", "partners"]
    },
    {
        // 관리자 - 대한문고 블랙리스트
        path: '/console/blacklist',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/BlackList.vue'),
        props: true,
        scope: ["console", "partners"]
    },
    {
        // 관리자 - 대한문고 블랙리스트
        path: '/console/blacklist/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/BlackIpView.vue'),
        props: true,
        scope: ["console", "partners"]
    },
    {
        // 관리자 - 대한문고 블랙리스트
        path: '/console/blacklist/:_ip',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/BlackIpView.vue'),
        props: true,
        scope: ["console", "partners"]
    },
    {
        // 관리자 - 관리자 화이트리스트
        path: '/console/whitelist',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/WhiteList.vue'),
        props: true,
        scope: ["console", "partners"]
    },  
    {
        // 관리자 - 관리자 화이트리스트
        path: '/console/whitelist/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/WhiteIpView.vue'),
        props: true,
        scope: ["console", "partners"]
    },
    {
        // 관리자 - 관리자 화이트리스트
        path: '/console/whitelist/:_ip',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/WhiteIpView.vue'),
        props: true,
        scope: ["console", "partners"]
    },
    {
        // 관리자 - CP 관리
        path: "/console/cps",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/partner/CpList.vue'),
        props: true,
        scope: ["console", "partners"]
    },
    {
        // 관리자 - CP 캐시내역
        path: "/console/cps/cashes",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/partner/CpCashList.vue'),
        props: true,
        scope: ["console", "partners"]
    },
    
    {
        // 관리자 - 
        path: "/console/pin/categories",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/pin/Category.vue'),
        props: true,
        scope: ["console", "partners"]
    },
    {
        // 관리자 - 핀 번호 관리
        path: "/console/pin/manager",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/pin/Manager.vue'),
        props: route => ({ ...route.query }),
        scope: ["console", "partners"]
    },
    {
        // 관리자 - 핀 발행(수동)
        path: "/console/pin/generate",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/pin/Generator.vue'),
        props: true,
        scope: ["console", "partners"]
    },
    {
        // 관리자 - 핀 업데이트
        path: "/console/pin/update",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/pin/Update.vue'),
        props: true,
        scope: ["console", "partners"]
    },
    {
        // 관리자 - 핀 폐기
        path: "/console/pin/cancel",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/pin/Cancel.vue'),
        props: true,
        scope: ["console", "partners"]
    },
    {
        // 관리자 - 통계(발행일 기준)
        path: "/console/pin/statistics/issued-at",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/pin/statistics/issued-at.vue'),
        props: true,
    },
    {
        // 관리자 - 정산
        path: "/console/pin/calculations",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/pin/Calculation.vue'),
        props: true,
    },
    {
        // 관리자 - 핀 유효기간(3개월 이내)
        path: "/console/pin/expire3",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/pin/Expire3.vue'),
        props: true,
        scope: ["console", "partners"]
    },
    {
        // 관리자 - 로그
        path: "/console/logs",
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/Log.vue'),
        props: true,
        scope: ["console", "partners"]
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

router.beforeEach((to, from, next) => {
    try {
        
        console.log({ hash :  to.hash });
        // var route = routes.find(route => route.name == to.name);
        const route = routes.find((route) => [to?.path, to?.matched?.[0]?.path].includes(route.path));
        if(!route) throw new Error("해당 페이지가 존재하지 않습니다");

        var accessToken = sessionStorage.getItem("accessToken");
        if(accessToken) axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

        if(!route.scope) next();
        else{
            if(!accessToken){
                if(to.name == "console"){ next(); return; }
                else throw new Error("로그인 후 이용가능합니다");
            }

            var payload = JSON.parse(atob(accessToken.split('.')[1]));
            var scope = payload.scope || [];

            if(!scope.find(scope => route.scope.includes(scope))){
                throw new Error("접근권한이 없습니다");
            }
            next();
        }
    }
    catch (error) {
        alert(error.message);
        window.location.href = routes.find(route => route.path == from.path)?.path ?? routes.find(route => route.path == "/")?.path ?? "about:blank";
    }
});

export default router
